import React, { useEffect, useState } from "react";
import "./descarga_LB.css";
// import NL_descarga_libro from '../../../assets/imgs/nuevo_libro/NL_descargar_libro.png'
import NL_descarga_line from "../../../assets/imgs/nuevo_libro/NL_descargar_line.png";
import LB_flecha_linea from "../../../assets/img/Vector 1.png";

// linea original
// import lib_bl from '../../../assets/img/Image_descar.png';

import lib_bl from "../../../assets/imgs/nuevo_libro/Image.png";

import { Debate_LB, Libr_azul } from "../../../container";

import { useTranslation } from "react-i18next";

const Descarga_LB = () => {
  const [lang, setLang] = useState(localStorage.getItem("language") || "es");
  const [langText, setLangText] = useState(
    lang === "es" ? "English" : "Español"
  );
  const [t, i18n] = useTranslation("librBlanc");

  return (
    <div class="NL_descarga">
      <div class="NL_descarga_laptop">
        <div class="NL_descarga_img">
        {i18n.language == 'es' ? (
          <img src={lib_bl} />
        ) : (
          <img src='https://www.ricardosalinas.com/images/Portada-Libro-Blanco-RBS_ingles-all.png' />
        )}
        </div>
        <div class="NL_descarga_content">
          <div class="NL_descarga_txt1">
            <p>
              <span class="NL_descarga_txt1_edit">{t("header.descarga")}</span>
              <span class="amaril">{t("header.gratis")}</span>
              <span class="NL_descarga_txt1_edit2">
                {" "}
                {t("header.frgmento4")}
                {t("header.frgmento")}{" "}
              </span>
              <span class="amaril2">{t("header.frgmento3")} </span>
              <span class="NL_descarga_txt1_edit3">
                {" "}
                {t("header.frgmento2")}
              </span>
              <span class="amaril2">{t("header.frgmento5")} </span>
              <span class="NL_descarga_txt1_edit3">
                {t("header.frgmento6")}{" "}
              </span>
            </p>
          </div>
          <div class="NL_descarga_line">
            {/* <img src={NL_descarga_line}/> */}
            <img src={LB_flecha_linea} />
          </div>
          {/* <div class="NL_descarga_txt2">
                    <p>
                    {(t('header.idea_mov'))}<br/> {(t('header.cambio'))}
                    </p>
                </div> */}
          <div class="NL_descarga_button">
            <a
              href="https://www.ricardosalinas.com/Content/assets/documents/ideas-BLANCO-PROLOGOS.pdf"
              target="_blank"
              download="fragmento-libro-sociedades.pdf"
              rel="noreferrer"
            >
              <button>{t("header.descarg")}</button>
            </a>
          </div>
        </div>
      </div>
      <div class="NL_descarga_movil">
        <div class="NL_descarga_img">
          <img src={lib_bl} />
        </div>
        <div class="NL_descarga_txt1">
          <p>
            Descarga gratis <br />
            un fragmento de mi{" "}
            <span class="NL_descarga_txt1_edit2">nuevo libro</span>
          </p>
        </div>
        <div class="NL_descarga_line">
          {/* <img src={NL_descarga_line}/> */}
          <img src={LB_flecha_linea} />
        </div>
        <div class="NL_descarga_txt2">
          <p>
            Ideas sobre la libertad que
            <br /> cambian al mundo
          </p>
        </div>
        <div class="NL_descarga_button">
          <button>Descargar</button>
        </div>
      </div>

      <Debate_LB />
      {/*<Libr_azul />*/}
    </div>
  );
};

export default Descarga_LB;
